export const RU = {
  preparing_zip: "Подготовка ZIP…",
  compressing: "Сжатие…",
  info_icon: "После того, как помечено как завершенное, дополнительные участники не могут присоединиться или быть добавлены, и все группы чата будут деактивированы. Обратите внимание, что проект вместе со всеми группами чата и данными останется доступным в деактивированном состоянии.",
  mark_is_done: "Вы уверены, что хотите отметить проект как завершенный? После отметки дополнительные участники не могут присоединиться или быть добавлены, и все группы чата будут деактивированы. Обратите внимание, что проект вместе со всеми группами чата и данными останется доступным в деактивированном состоянии.",
  mark_not_done: "Вы уверены, что хотите снова открыть проект? После отметки как открытого дополнительные участники могут присоединиться или быть добавлены, и все группы чата будут реактивированы.",
  mark_as_completed: "Отметить проект как завершенный",
  room_completed: "Проект завершён",
  room_members: "Участники проекта",
  deactivated_rooms: "Деактивированные проекты",
  deactivated_chats: "Деактивированные чаты",
  completed_rooms: "Завершенные проекты",
  request_to_join_a_room: 'Запрос на присоединение к проекту',
  wants_to_rejoin_room: 'Username хочет снова присоединиться к проекту Roomname.',
  invited_you_to_join_room: 'Username пригласил вас присоединиться к проекту Roomname.',
  restart: "Перезапустить",
  update_text: "Доступно новое обновление. Нажмите перезапустить, чтобы установить обновление.",
  update_availble: "Доступно обновление",
  Loading: "Загрузка...",
  logout: "Выйти",
  back: 'Назад',
  company_list: "Список компаний",
  followers: "Подписчики",
  followings: "Подписки",
  article: "Статья",
  companies: "Компании",
  one_to_one_chat: " Чат один на один",
  profile: "Профиль",
  company: "Компания",
  company_selection: "Выбор компании",
  home: "Главная",
  contact: "Контакт ",
  add_company: "Добавить компанию ",
  add_project: "Добавить проект ",
  capacities: "Мощности ",
  work_area: "Рабочая область",
  company_services: "Услуги компании",
  website: "Веб-сайт",
  search_contacts: "Поиск контактов",
  add_or_join_a_company: "Добавить или присоединиться к компании",
  follow: "Подписаться",
  following: "Подписка",
  like: "Нравится",
  company_contacts: "Контакт компании",
  leave_the_company: "Покинуть компанию",
  news: "Новости",
  earlier: "Ранее",
  action: "Действие",
  another_action: "Другое действие",
  something_else: "Что-то еще",
  search: "Поиск",
  search_rooms: "Поиск проектов",
  search_articles: "Поиск статей",
  contacts: "Контакты",
  suggestions: "Предложения",
  project_list: "Список проектов",
  search_results: "Результаты поиска",
  add_or_join_project: "Добавить или присоединиться к проекту",
  details: "Детали",
  your_position_within_company:
    "Пожалуйста, выберите вашу должность в компании.",
  close_modal: "Закрыть",
  map: "Карта",
  or: "Или",
  name: "Имя*",
  street: "Улица*",
  house_number: "Номер дома",
  postal_code: "Почтовый индекс",
  city: "Город*",
  opened_by: "Открыто:",
  project_No: "Номер проекта: ",
  building_type: "Тип здания*",
  building_types: "Тип здания",
  add_join: "Добавить/Присоединиться",
  mandatory_fiels: "*обязательные поля",
  invalid_fiels: "Это поле обязательно",
  add_or_join_company: "Добавить или присоединиться к компании",
  name_of_the_company: "Название компании",
  edit_company_details: "Редактировать данные компании",
  branch_of_the_building_industry: "Отрасль строительной индустрии",
  corporate_form: "Организационно-правовая форма",
  position_within_company: "Должность в компании",
  request_confirmation: "Ожидающие запросы на проекты",
  company_e_mail: "Электронная почта компании",
  type_of_filter: "Введите для фильтрации...",
  setting: "Настройка",
  dashboard: "Панель управления",
  settings: "Настройки",
  views: "Просмотры",
  times_seen: "раз просмотрено",
  see_more: "...еще",
  see_less: "...меньше",
  in_search: "в поиске",
  reset_password: "Сбросить пароль",
  submit: "Отправить",
  password: "Пароль",
  email: "Электронная почта",
  confirm_password: "Подтвердить пароль",
  reset_email: "Сбросить электронную почту",
  update: "Обновить",
  new_email: "Новая электронная почта",
  kjuup_message: "Сообщение Kjuup",
  delete_profile: "Удалить профиль?",
  my_position: "Моя должность:",
  add: "добавить",
  owner_company_admin: "Администратор компании :",
  owner_company_admin_new: "Администратор компании",
  mutual_contact: "общий контакт",
  mutual_contacts: "общие контакты",
  co_owner: "Совладелец",
  managing_director: "Генеральный директор",
  associate: "Партнер",
  secretary: "Секретарь",
  employee: "Сотрудник",
  project_manage: "Менеджер проекта",
  auto_chat_translation: "Автоматический перевод чата",
  translate_room_group_names: "Переводить названия групп чата",
  translate_room_group_names_info: "При включении названия групп чата автоматически переводятся на язык интерфейса.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "При включении вкладка E-Mail будет открываться по умолчанию вместо Сообщений при открытии приложения.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Язык",
  english: "Английский",
  german: "Немецкий",
  french: "Французский",
  italian: "Итальянский",
  change_language: "Изменить язык",
  my_companies: "Мои компании",
  employees: "Сотрудники",
  invite_with_a: "Пригласить в Kjuup",
  add_member: "Добавить участника",
  add_user: "Добавить пользователя",
  send_location: "Отправить местоположение",
  assign_admin_rights: "Настроить права администратора",
  deactivate_company: "Деактивировать компанию",
  remove_employees: "Удалить сотрудников",
  remove_members: "Удалить участников",
  no_user_found: "Пользователь не найден!",
  approve: "Одобрить!",
  deselect_all: "Снять все выделения",
  select_all: "Выбрать все",
  translation_on_building_projects: "Перевод в проектах",
  reported_capacities: "Сообщенные услуги",
  up_to_50m_exact: "До 50м точно",
  company_details_service: "Услуги компании",
  company_contact: "Контакт компании",
  invite_with_link: "Пригласить в Kjuup",
  share_link: "Поделиться ссылкой",
  share_company_link: "Поделиться ссылкой",
  qr_code: "QR-код",
  copy_link: "Копировать ссылку",
  cancel_link: "Отменить ссылку",
  who_has_confirmed_services: "Кто подтвердил ваши услуги?",
  projectss: "Проекты",
  add_services: "Добавить услуги",
  services: "Услуги",
  save_text: "Сохранить",
  share_on: "Поделиться на:",
  articlen: "Статья",
  invite_user_to_confirm_service:
    "Пригласите пользователей подтвердить услуги компании.",
  link_copied: "Ссылка скопирована!",
  email_copied: "Электронная почта скопирована!",
  personal_article: "Личная статья",
  company_article: "Статья компании",
  characters_remaining: "Осталось символов",
  optional_information: "Дополнительная информация",
  project: "Проект",
  projects: "Проекты...",
  abort: "Отменить",
  preview: "Предпросмотр",
  post: "Опубликовать",
  of: "из",
  remove: "Удалить",
  free_capacity: "Портал вакансий",
  current_status_overview: "Обзор текущего статуса",
  report_capacities: "Сообщить об услугах",
  report_text: "Сообщить",
  search_capacities: "Найти подрядчиков",
  add_project_user: "Добавить пользователя проекта",
  media: "Медиа",
  links: "Ссылки",
  docs: "Документы",
  featured_products: "Рекомендуемые продукты...",
  title: "Заголовок",
  text: "Текст",
  feed_details: "Детали ленты",
  add_employee: "Добавить сотрудника",
  latest: "Последние",
  my_projects: "Мои проекты",
  cancel: "Отмена",
  continue: "Продолжить",
  role_in_the_building_industry: "Роль в строительной индустрии",
  als: "как",
  join: "присоединиться",
  find: "Найти",
  request_to_join_a_company: "Запрос на присоединение к компании",
  wants_to_join_the_company: "хочет присоединиться к компании",
  filter_by: "Фильтровать по",
  ok: "Ок",
  close: "Закрыть",
  weekly_statistics: "Еженедельная статистика",
  is_following_you: "подписался на вас.",
  as: "как",
  has_joined_the: "присоединился к компании",
  has_looked_at_your_profile: "просмотрел ваш профиль.",
  time: "Время",
  in_searches_in_past_week: "в поисках за прошлую неделю.",
  has_liked_your_article: "понравилась ваша статья.",
  has_published_a_new_article: "опубликовал новую статью.",
  you: "Вы",
  all_views: "Все просмотры",
  all_profile_views: "Все просмотры профиля",
  mutual_company: "общая компания",
  artical_text: "Написать статью...",
  you_have_appeared: "Вы появились",
  your_request_at_the_company: "Ваш запрос в компании",
  times_you_have_appeared_in_searches: "раз вы появились в поисках",
  appear_more_often_in_searches: "Появляться чаще в поисках",
  you_have_been_found: "Вас нашли",
  improve_profile: "Улучшить профиль",
  choose_existing_contact_for_single_chat:
    "Выберите существующий контакт для индивидуального чата:",
  in_order_to_add_new_contacts:
    "Чтобы добавить новые контакты, пожалуйста, найдите новые контакты на странице профиля.",
  times_in_searches_in_the_last_week:
    "раз в поисках за последнюю неделю. Обновите свой профиль и добавьте дополнительные детали, чтобы вас было легче найти.",
  has_been_confirmed: "было подтверждено.",
  have_joined_the: "присоединились к  ",
  building_project: " строительному проекту.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Выберите компанию, которую вы будете представлять. Это будет отображаться другим участникам.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Выберите компанию, которую вы будете представлять. Это будет отображаться другим участникам.",
  select_internal_section: "Пожалуйста, выберите внутренний раздел",
  select_profile_image: "Выбрать изображение профиля",
  share_user: "Поделиться пользователем",
  contact_sender_message:
    "Поделитесь этой ссылкой, чтобы пригласить не участника Kjuup в Kjuup. Этой ссылкой могут воспользоваться несколько человек для регистрации.",
  project_sender_message:
    "Поделитесь этой ссылкой, чтобы пригласить не участника Kjuup в проект название проекта. Этой ссылкой могут воспользоваться несколько человек для регистрации и присоединения к проекту название проекта в Kjuup.",
  company_sender_message:
    "Поделитесь этой ссылкой, чтобы пригласить не участника Kjuup в компанию название компании. Этой ссылкой могут воспользоваться несколько человек для регистрации и присоединения к компании в Kjuup.",
  contact_receivers_message:
    "Ссылка-приглашение для присоединения к Kjuup. Пожалуйста, нажмите на ссылку для регистрации в kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "В случае, если вы устанавливаете Kjuup через Apple App Store, вы должны нажать на эту ссылку после успешной загрузки, чтобы иметь возможность зарегистрироваться.",
  project_receivers_message:
    "Ссылка-приглашение для присоединения к проекту название проекта в Kjuup. Пожалуйста, нажмите на ссылку для регистрации в Kjuup и присоединения к проекту название проекта.",
  company_receivers_message:
    "Ссылка-приглашение в компанию название компании в Kjuup. Пожалуйста, нажмите на ссылку для регистрации в Kjuup и присоединения к компании название компании.",
  sign_in: "Войти",
  enter_your_email_add: "Введите ваш адрес электронной почты",
  forgot_password: "Забыли пароль?",
  dont_have_account: "Нет аккаунта?",
  register: "Зарегистрироваться",
  get_app: "Получить приложение",
  registration: "Регистрация",
  dep_ing: "Dipl.-Ing.",
  dr: "Доктор",
  dr_ing: "Доктор-инженер",
  dep_ing_arc: "Dipl.-Ing. Архитектор",
  prof: "Проф.",
  first_name: "Имя",
  last_name: "Фамилия",
  have_an_account: "Есть аккаунт?",
  when_register_you_agree: "При регистрации вы соглашаетесь с нашими",
  term_of_use: "условиями использования",
  to: "к.",
  in_our: "В нашей",
  data_policy: "политике данных",
  they_find_out: "они узнают,",
  we_provide_store_data: "как мы собираем, обрабатываем и храним информацию.",
  leaving_company_text:
    "Вы действительно хотите покинуть компанию? При выходе из компании вы также покидаете все связанные проекты и группы чата. Вы можете снова присоединиться к этим проектам с другой компанией в любое время.",
  delete_profile_text:
    "Вы действительно хотите удалить свой профиль? При удалении профиля все связи с компаниями, проектами и чатами будут удалены. Вы можете создать новый профиль в любое время.",
  confirm: "Подтвердить",
  reject: "Отклонить",
  requet_to_leave: "Запрос на выход",
  choose: "Выбрать",
  your_add_member: "Добавить участника",
  if_you: "если вы",
  can_not_find: "не можете найти свой контакт здесь.",
  please_wait: "Пожалуйста, подождите..",
  imprint_gtc: "Оттиск/Условия использования",
  register_confirm_popup: "Подтвердите адрес электронной почты Kjuup перед входом. Мы отправили ссылку для подтверждения. Если письма нет, проверьте папку «Спам».",
  PENDING_GROUP_USER:
    "будет получать сообщения только после подтверждения приглашения в проект. Дополнительное сообщение появится после подтверждения приглашения в проект.",
  PENDING: "Подтверждение приглашения в проект ожидается",
  denied_group_chat: " отклонил приглашение в проект и покинул эту группу.",
  // joined_group_chat: " присоединился к комнате и этой группе.",
  joined_group_chat: " присоединился к этой группе",
  you_joined_group_chat: "Вы присоединились к этой группе.",
  Others: "Другие",
  LEFT_GROUP: "покинул эту группу чата.",
  YOU_LEFT_GROUP: "покинули эту группу чата.",
  days: "дней",
  day: "день",
  hour: "час",
  hide_project: "Скрыть проект",
  hide_project_popup_text:
    "Если вы скрываете проекты, они не могут быть найдены в Kjuup. Только участники проекта могут приглашать новых пользователей в проект.",
  branch: "Отрасль",
  photo_video_media_lib: "Медиатека - Фото и видео",
  document: "Документ",
  location_meeting: "Местоположение / Встреча",
  all_member_of_project: "Все участники проекта",
  pending_request: "Ожидающие запросы на проекты",
  no_pending_request: "Ожидающих запросов не найдено!",
  news_feed: "Лента новостей",
  user_info: "Информация о группе",
  leave_project: "Покинуть проект",
  media_link_docs: "Файлы",
  search_chat: "Поиск в чате",
  export_chat_group: "Экспортировать данные группы чата за последний месяц",
  request_complete_chat_history: "Запросить полную историю чата",
  leave_chat_group: "Покинуть группу чата",
  add_user_project: "Добавить пользователя",
  me: "Я",
  max_open_one_to_one:
    "В настоящее время макс. 2 индивидуальных чата могут быть открыты параллельно в нижней и верхней секции. Всего макс. 4 индивидуальных чата возможны.",
  are_you_sure_you_want_leave_chat:
    "Вы уверены, что хотите покинуть эту группу чата?",
  create_group: "Создать группу",
  adding_members: "Добавление участников...",
  creating_the_chat: "Создание чата...",
  finishing_setup: "Завершение настройки...",
  group_name: "Название группы",
  by: "От:",
  mandetory: "*обязательно",
  delteed: "удалил(а) свой профиль и покинул(а) групповой чат.",
  deleted_direct: "удалил(а) свой профиль и покинул(а) чат.",
  unhidden_message:
    "Если вы показываете проекты, они могут быть найдены всеми участниками Kjuup.",
  account_deleted: "Аккаунт был удален.",
  refuse_company: "Вы уверены, что хотите отклонить приглашение компании?",
  follow_additional: "Подписаться на дополнительных пользователей",
  f_add:
    "Подпишитесь на дополнительных пользователей Kjuup, чтобы сделать их доступными для прямых сообщений.",
  c_inv: "Приглашение(я) компании",
  invited_o_Company: "Вас пригласили присоединиться к компании",
  refuse_companyX: "Вы уверены, что хотите отклонить запрос компании?",
  a_Da: "Аккаунт деактивирован.",
  has_deactivated: "деактивировал(а) свой профиль.",
  reactive: "реактивировал(а) свой профиль.",
  juup_note: "*Регистрация с именем пользователя доступна только для участников Kjuup+",
  username: "Имя пользователя*",
  email_username: "Электронная почта/Имя пользователя*",
  sPinText:
    "Пожалуйста, укажите 6-значный PIN-код безопасности. Этот PIN-код понадобится, если вы забудете свой пароль, и обязателен для подтверждения вашего аккаунта.",
  DeleteKjuupPlusText:
    "Вы действительно хотите удалить свой профиль? При удалении профиля все связи с компаниями, проектами и чатами будут удалены.\n\nВ течение 48 часов после удаления аккаунта вы можете реактивировать свой аккаунт, войдя с именем пользователя, паролем и PIN-кодом.",
  reactive_text:
    "Ваш аккаунт был удален. Пожалуйста, нажмите на Реактивировать, чтобы реактивировать ваш аккаунт.",
  rac: "Реактивировать",
  ac_ss: "Аккаунт успешно реактивирован.",
  not_valid_pin: "PIN-код недействителен",
  only_for_kjuup:
    "*Сброс пароля через имя пользователя и PIN-код доступен только для участников Kjuup+.",
  resetPIN: "Сбросить PIN-код",
  enter_current_pin: "Пожалуйста, введите ваш текущий PIN-код",
  enter_new: "Введите новый PIN-код",
  pin_to_confirm: "Пожалуйста, укажите PIN-код для подтверждения.",
  change_username: "Сбросить имя пользователя",
  pp_not_match: "Пароль и подтверждение пароля не совпадают",
  reactive_itself: "Вы реактивировали свой профиль.",
  has_deactivated_itself: "Вы деактивировали свой профиль.",
  more_than_two:
    "В настоящее время прямые сообщения могут быть отправлены только 2 пользователям параллельно.",
  Chats: "Прямые сообщения",
  only_in_mobileL:
    "Нативные видео в настоящее время могут быть загружены и опубликованы только через мобильное приложение. Пожалуйста, используйте ссылки на видео YouTube и Vimeo.",
  register_pin_text:
    "Пожалуйста, выберите ваш личный 6-значный PIN-код. Этот PIN-код понадобится для включения функций сброса аккаунта.",
  internal_project: "Внутренний",
  external_projects: "Внешний",
  in_deacticted: "Внутренний раздел деактивирован.",
  create_article: "Создать статью",
  new_article_selection: "Создать статью для внешней ленты новостей",
  new_article_selection_internal: "Создать внутреннюю статью",
  active_trans_title: "Включить автоматический перевод?",
  active_trans: "При включении все входящие сообщения чата будут переведены на выбранный язык приложения.",
  disable_trans: "Вы действительно хотите деактивировать автоматический перевод?",
  allow_access_chat: "Показать полную историю чата",
  toggle_chat_history_on:
    "Вы действительно хотите, чтобы пользователь видел полную историю чата?",
  toggle_chat_history_off:
    "Вы действительно хотите, чтобы пользователь видел только историю чата с момента присоединения к чату?",
  check_selected_settings:
    "Пожалуйста, проверьте настройки истории чата для всех выбранных пользователей!",
  chat_from_start_have:
    "Вы присоединились к этой группе. История чата была предоставлена.",
  chat_from_start_has:
    "присоединился к этой группе. История чата была предоставлена.",
  Address: "Адрес",
  read_by: "Прочитано",
  deliver_to: "Доставлено",
  remaining: "осталось",
  message_info: "Информация о сообщении",
  request_to_join_only: "Запрос на присоединение",
  unfollow: "Отписаться",
  company_username: "Имя пользователя",
  month: [
    "Янв",
    "Фев",
    "Мар",
    "Апр",
    "Май",
    "Июн",
    "Июл",
    "Авг",
    "Сен",
    "Окт",
    "Ноя",
    "Дек",
  ],
  remove_my_admin_right: "Удалить мои права администратора",
  makeEmp: "Вы действительно хотите удалить права администратора компании у пользователя?",
  remove_my_self:
    "Вы действительно хотите удалить права администратора компании у вашего аккаунта?",
  makeAdmin: "Вы действительно хотите предоставить пользователю права администратора компании?",
  remove_member: "Удалить участника",
  remove_following_confirm: "Вы действительно хотите удалить {name} из списка подписок?",
  remove_follower_confirm: "Вы действительно хотите удалить {name} из подписчиков? Если вы удалите его/её, он/она не будет уведомлен(а).",
  do_you_really_want_to_remove:
    "Вы действительно хотите удалить имя пользователя из компании?",
  invite_all: "Пригласить всех участников компании",
  invite_all_members: "Пригласить всех участников",
  mems: "Все остальные участники",
  dep_loc: "Отдел/Местоположение/Команда",
  depAdmin: "Администратор отдела",
  add_remove_admin: "Добавить/Удалить должность администратора компании",
  add_remove_dep_admin: "Добавить/Удалить должность администратора отдела",
  remove_employees_dept: "Удалить сотрудников из",
  want_to_join_dep:
    "Имя пользователя хочет присоединиться к Отделу/Местоположению/Команде depname компании companyname.",
  you_invited:
    "Вас пригласили присоединиться к Отделу/Местоположению/Команде depname компании companyname.",
  dep_remove:
    "Вы действительно хотите удалить права администратора отдела или местоположения у пользователя?",
  add_dep:
    "Вы действительно хотите предоставить пользователю права администратора для отдела или местоположения?",
  my_self_dep_remove:
    "Вы действительно хотите удалить права администратора отдела у вашего аккаунта?",
  member: "Участник",
  admin: "Администратор",
  remove_project_admin:
    "Вы действительно хотите удалить участника из проекта?",
  remove_my_self_project: "Вы действительно хотите удалить права администратора?",
  remove_member_admin_right:
    "Вы действительно хотите удалить права администратора у пользователя?",
  add_member_admin_right: "Вы действительно хотите добавить права администратора пользователю?",
  add_remove_Poss: "Добавить/Удалить должность администратора",
  forward: "Переслать",
  edit: "Редактировать",
  only_kjuup_plus_can: "Только компании Kjuup+ могут публиковать статьи.",
  add_images: "Добавить изображение(я)",
  request_confirmation: 'Ожидающие приглашения в проекты',
  Activity: "Активность",
  latest_messages: "Последние сообщения",
  hours: "часов",
  minute: "минут",
  seconds: "секунд",
  days: "дней",
  yesterday: "вчера",
  last_week: "на прошлой неделе",
  next_week: "на следующей неделе",
  Last_month: "в прошлом месяце",
  All: "Все",
  register_plus: "Регистрация Plus",
  select_files: "Выбрать файлы",
  monthsFullName: [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ],
  company_deploc_receivers_message:
    "Ссылка-приглашение в отдел компании название компании в Kjuup. Пожалуйста, нажмите на ссылку для регистрации в Kjuup и присоединения к компании название компании.",
  no_news: "Новости недоступны",
  reminder: "Напоминание",
  np_reminder: "Нет задач",
  move_to_reminder: "Переместить в задачу",
  remove_reminder: "Вы действительно хотите удалить это сообщение из списка ваших задач?",
  remove_all_reminder: "Удалить все задачи",
  remove_all_confirm: "Вы действительно хотите удалить все сообщения из списка ваших задач?",
  remove_from_reminder: "Удалить из напоминания",
  prevent_email: "Электронная почта не может быть использована как имя пользователя.",
  allow_noti: "Пожалуйста, разрешите уведомления.",
  join_cap: "Присоединиться",
  pass_minimum:
    "**Пароль требует 12 символов, включая строчную букву, заглавную букву, цифру и специальный символ.",
  pass_error: "Пожалуйста, проверьте требования к паролю",
  people_that_like_article: "Люди, которым нравится статья.",
  people_who_like_article: "Люди, которым нравится ваша статья.",
  message_delete: "Это сообщение было удалено.",
  message_edited: "изменено",
  edit_message: "Редактировать сообщение",
  edit_window_expired: "Сообщения можно редактировать только в течение 10 минут после отправки.",
  message_edit_save: "Сохранить",
  copy: "Копировать",
  bookmark: "Закладка",
  add_reaction: "Добавить реакцию",
  delete_message: "Удалить сообщение",
  more_options: "Ещё",
  info: "Инфо",
  link_invite: "Пригласить по ссылке",
  ll_nkk: "Пригласить в Kjuup",
  selected: "Выбрано",
  is_active: "Активно",
  inactive: "Неактивно",
  last_online: "был(а) в сети {{when}}",
  remove_user_l: "Удалить",
  link_expire: "Каждая сгенерированная ссылка будет действительна в течение 72 часов.",
  company_language: "Язык компании",
  company_language_info:
    "Выбор языка будет использоваться для всех подтверждений по электронной почте, касающихся компании.",
  s_image: "изображение",
  m_image: "изображения",
  removeMsg: "Нажмите, чтобы удалить",
  block: 'Заблокировать',
  unblock: 'Разблокировать',
  blocks: 'Вы уверены, что хотите заблокировать этого пользователя?',
  unblocks: 'Вы уверены, что хотите разблокировать этого пользователя?',
  bolcked_click_un_block:
    'Вы заблокировали этот контакт. Нажмите здесь, чтобы снять блокировку.',
  you_have_unblocked: 'Вы разблокировали этот контакт.',
  you_have_blocked: 'Вы заблокировали этот контакт.',
  unblock_to_send: 'Разблокируйте пользователя, чтобы отправить сообщение.',
  pilot_text: "Специализированный ИИ для тем строительства",
  startup_screen_label: "Стартовый экран",
  startup_screen_info: "Выберите, какой экран открывается при запуске Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Сообщения",
  startup_screen_saved: "Стартовый экран обновлён",
email_on: "Уведомления по электронной почте чатов",
  email_on_grp: "Уведомление по электронной почте",
  article_email_on: "Уведомления по электронной почте о статьях",
  article_email_info: "Если вы включите уведомления по электронной почте для внутренних статей, вы получите письмо, когда новая внутренняя статья будет опубликована в вашей компании и отделе.",
  info_email_room: "Активировать или деактивировать уведомления по электронной почте для этого проекта. Эта опция доступна только когда \"Уведомления по электронной почте чатов\" включена через личные настройки.",
  todo_notification_info: "Вы будете получать уведомление каждый раз, когда вам назначается новая задача.",
  info_val: "Вы получите письмо, если новое сообщение в чате не будет прочитано в течение короткого времени. Вы можете отключить это для отдельных проектов или чатов в их настройках или в информации группы чата.",
  email_groups: "Активировать или деактивировать уведомления по электронной почте для этого чата. Эта опция доступна только когда \"Уведомления по электронной почте чатов\" включена через личные настройки и настройки проекта.",
  add_update_email: "Добавить/Обновить электронную почту",
  text_to_verifiy: "Опция \"Уведомления по электронной почте чатов\" может быть включена только если у вас есть подтвержденный адрес электронной почты в файле.",
  stored_email: "Сохраненная электронная почта: ",
  verify_email: "Подтверждение ожидается!",
  join_call:"Присоединиться",
  call_is_started:"Звонок начался",
  start_chat:"Начать прямой чат?",
  project_rooms:"Проекты",
  download_selected:"Скачать",
  add_employee_confirm: 'Вы уверены, что хотите добавить этого пользователя в компанию?',
  invalid_deeplink: "Недействительный URL глубокой ссылки. Отсутствуют обязательные параметры.",
  deeplink_error: "Не удалось обработать глубокую ссылку. Пожалуйста, попробуйте позже.",
  // Reply functionality translations
  reply: "Ответить",
  reply_enter: "Введите ответ...",
  reply_sent_successfully: "Ответ отправлен успешно",
  reply_failed: "Не удалось отправить ответ",
  reply_failed_generic: "Не удалось отправить ответ. Пожалуйста, попробуйте снова.",
  replying_to_message: "Ответ на сообщение",
  cancel_reply: "Отменить ответ",
  voice_message: "Голосовое сообщение",
  send: "Отправить",
  cancel: "Отмена",
  type_your_reply: "Введите ваш ответ...",
  
  // Auto-suggestion translations
  suggested_replies: "Предложенные ответы",
  suggestions_error: "Не удалось загрузить предложения",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Изображение — Нажмите для загрузки",
  lazy_media_audio: "Голосовое сообщение — Нажмите для загрузки",
  lazy_media_doc: "Документ — Нажмите для загрузки",
  lazy_media_video: "Видео — Нажмите для загрузки",
  suggestion_loading_message: "Один момент. Ваш текст готовится индивидуально для вас.",
  loading_chat_message: "Загрузка чата...",
  
  // Manual ToDo translations
  extracting_message: "Извлечение сообщения...",
  create_todo: "Создать задачу",
  create_todo_confirmation: "Вы хотите создать задачу из этого сообщения?",
  select_project_required: "Пожалуйста, выберите проект/группу",
  only_assigned_can_change_status: "Только назначенные пользователи могут изменить статус",
  todo_summary: "Резюме",
  todo_summary_placeholder: "Введите резюме задачи...",
  todo_date: "Дата",
  todo_time: "Время",
  todo_date_hint: "Оставьте пустым, чтобы использовать дату/время исходного сообщения",
  todo_created_success: "Задача создана успешно",
  todo_creation_failed: "Не удалось создать задачу",
  create: "Создать",
  
  image: "изображение",
  images: "изображения",
  remove_all_images: "Удалить все изображения",
  remove_image: "Удалить изображение",
  remove_document: "Удалить документ",
  remove_recording: "Удалить запись",
  play_recording: "Воспроизвести запись",
  upload_image: "Загрузить изображение",
  upload_document: "Загрузить документ",
  record_audio: "Записать аудио",
  stop_recording: "Остановить запись",
  stop_recording_text: "Остановить запись",
  please_remove_current_attachment: "Пожалуйста, удалите текущее вложение для",
  please_upload_image_file: "Пожалуйста, загрузите действительный файл изображения",
  please_upload_valid_document: "Пожалуйста, загрузите действительный файл документа",
  searching_messages: "Поиск сообщений...",
  loading_more: "Загрузка еще...",
  loading_more_users: "Загрузка еще пользователей...",
  load_more_users: "Загрузить еще пользователей",
  no_more_users_to_load: "Больше нет пользователей для загрузки",
  no_messages_found: "Сообщения не найдены",
  try_different_keyword: "Попробуйте другое ключевое слово или проверьте правописание.",
  search_messages: "Поиск сообщений, чат-групп, проектов и пользователей...",
  todo: "Задача",
  np_todo: "Нет задач",
  move_to_todo: "Сохранить как задачу",
  remove_todo: "Вы действительно хотите удалить задачу?",
  remove_all_todo: "Удалить все задачи",
  remove_all_todo_confirm: "Вы действительно хотите удалить все задачи?",
  add_to_todo: "Добавить в задачу",
  remove_from_todo: "Удалить из задачи",
  confirm: "Подтвердить",
  ok: "Ок",
  read_more: "Читать далее",
  show_less: "Показать меньше",
  show_more: "Показать больше",
  audio: "Аудио",
  video: "Видео",
  // Notification Settings
  notification_schedule: "Расписание уведомлений",
  notification_schedule_desc: "Вы будете получать push- и email-уведомления только в выбранные часы. Вне этих часов они будут приостановлены.",
  learn_more: "Узнать больше",
  allow_notifications: "Разрешить уведомления:",
  every_day: "Каждый день",
  weekdays: "Будние дни (понедельник - пятница)",
  custom: "Пользовательский",
  monday: "Понедельник",
  tuesday: "Вторник",
  wednesday: "Среда",
  thursday: "Четверг",
  friday: "Пятница",
  saturday: "Суббота",
  sunday: "Воскресенье",
  to: "до",
  notification_settings: "Уведомления",
  notification_settings_saved: "Настройки уведомлений сохранены успешно",
  notification_settings_error: "Не удалось сохранить настройки уведомлений",
  unavailability_note: "Уведомление об отсутствии",
  unavailability_description: "Установите уведомление об отсутствии. Пока оно активно, уведомление отображается другим во всех ваших чатах, а уведомления приостановлены.",
  unavailability_start_date: "Дата начала",
  unavailability_end_date: "Дата окончания",
  unavailability_message: "Сообщение",
  unavailability_message_hint: "Используйте {endDate} в качестве заполнителя для даты возвращения.",
  unavailability_replacement: "Замещающий контакт",
  unavailability_replacement_placeholder: "Введите ID пользователя для срочных запросов",
  unavailability_replacement_current: "Текущий заместитель",
  unavailability_replacement_hint: "Если задано, в уведомлении об отсутствии будет показана ссылка для связи с этим человеком по срочным вопросам.",
  unavailability_replacement_none: "Без замещения (необязательно)",
  unavailability_contact_urgent: "По срочным вопросам обращайтесь к",
  unavailability_default_message: "В настоящее время я не в офисе и не имею доступа к Kjuup. Я снова буду доступен с {endDate} и свяжусь с вами тогда.",
  unavailability_save: "Сохранить",
  unavailability_deactivate: "Деактивировать",
  unavailability_active_until: "Активно до",
  unavailability_saved: "Уведомление об отсутствии сохранено",
  unavailability_save_error: "Не удалось сохранить уведомление об отсутствии",
  unavailability_deactivated: "Уведомление об отсутствии деактивировано",
  unavailability_end_date_required: "Дата окончания обязательна",
  start_time_before_end_time: "Время начала должно быть раньше времени окончания",
  loading: "Загрузка",
  disabled: "Отключено",
  enable: "Включить",
  disable: "Отключить",
  forwarded: "Переслано",
  message_forwarded: "Сообщение переслано!",
  // Schedule Article
  schedule_article_post: "Запланировать публикацию статьи",
  date: "Дата",
  time: "Время",
  scheduled_for_publication: "Запланировано для публикации",
  article_will_be_published_on: "Статья будет опубликована:",
  reset_selection: "Сбросить выбор",
  continue: "Продолжить",
  cancel: "Отмена",
  // Member Selection
  error_loading_members: "Ошибка загрузки участников",
  please_fill_all_fields: "Пожалуйста, заполните все поля",
  invalid_email: "Недействительный адрес электронной почты",
  member_added_successfully: "Участник добавлен успешно",
  error_onboarding_user: "Ошибка добавления пользователя",
  error_creating_chat: "Ошибка создания чата",
  error_creating_group: "Ошибка создания группы",
  new_group: "Новая группа",
  please_select_or_enter_group_name: "Пожалуйста, выберите группу или введите название группы",
  please_select_or_enter_room_name: "Пожалуйста, выберите проект или введите название проекта",
  error_creating_room: "Ошибка создания проекта",
  error_opening_chat: "Ошибка открытия чата",
  privacy_modal_text: "Выберите \"Приватный\" только если чат не содержит релевантного профессионального контента для менеджера проекта.",
  not_private: "Не приватный",
  private: "Приватный",
  error_loading_groups: "Ошибка загрузки групп",
  automatic_chat_export: "Автоматический экспорт чата",
  automatic_chat_export_info: "После активации история чата будет автоматически отправляться на указанный адрес электронной почты каждый месяц.",
  automatic_chat_export_no_email: "Чтобы включить автоматический экспорт чата, сначала необходимо добавить адрес электронной почты. Вы можете добавить свой адрес электронной почты в личных настройках.",
  enter_email: "Введите электронную почту",
  update: "Обновить",
  confirm: "Подтвердить",
  export_to_email: "Экспорт идет на следующую электронную почту.",
  start_chat_button:"Новое сообщение",
  matching_existing_chats: "Соответствующие существующие чаты",
  subject: "Тема",
  add_subject: "Добавить тему",
  chat_subject: "Тема чата:",
  set_project_room: "Установить проект",
  matching_existing_project_rooms: "Соответствующие существующие проекты",
  name_project_room: "Назвать проект",
  professional_or_private: "Профессиональный или приватный",
  professional: "Профессиональный",
  privacy_modal_text_updated: "Выберите \"Приватный\" только если чат не содержит релевантного профессионального контента для менеджеров проекта. Приватные чаты не видны менеджерам проекта.",
  create_internal_chat: "Внешний - или внутренний чат?",
  internal_chat_description: "Только сотрудники вашей компании могут быть добавлены во внутренние чаты.",
  yes: "Да",
  no: "Нет",
  chat_is_being_created: "Чат создается...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Вы действительно хотите отменить изменения в этой статье?",
  please_enter_article_title: "Пожалуйста, сначала введите заголовок статьи.",
  please_add_mandatory_fields: "Пожалуйста, добавьте все обязательные поля",
  product_label: "Продукт:",
  no_companies_found: "Компании не найдены",
  visible_to_all_followers: "Видно всем участникам Kjuup",
  only_visible_to_employees: "Видно только сотрудникам",
  something_went_wrong: "Что-то пошло не так, пожалуйста, попробуйте снова",
  please_select_department: "Пожалуйста, выберите отдел/местоположение",
  schedule: "Запланировать",
  please_select_future_date_time: "Пожалуйста, выберите будущую дату и время для планирования статьи.",
  please_select_different_date_time: "Пожалуйста, выберите другую дату или время для планирования статьи.",
  please_select_later_time: "Пожалуйста, выберите время позже текущего времени на сегодня.",
  unpin_article: "Открепить статью",
  pin_article: "Закрепить статью",
  and: "и",
  others: "другие",
  at: "в",
  // Chat mute/unmute translations
  mute: "Заглушить",
  unmute: "Включить звук",
  chat_muted_successfully: "Чат успешно заглушен",
  chat_unmuted_successfully: "Звук чата успешно включен",
  mute_chat_confirm: "Вы действительно хотите заглушить этот чат? Вы больше не будете получать уведомления о новых сообщениях.",
  unmute_chat_confirm: "Вы действительно хотите включить звук этого чата? Вы снова будете получать уведомления о новых сообщениях.",
  please_select_group_to_forward: "Пожалуйста, выберите группу для пересылки сообщения",
  // Company translations
  record_not_found: "Запись не найдена!",
  please_select_position: "Пожалуйста, выберите должность",
  delete_article_confirm: "Вы уверены, что хотите удалить эту статью?",
  delete_company_service_confirm: "Вы уверены, что хотите удалить услугу компании?",
  block_translation_confirm: "Вы действительно хотите заблокировать автоматический перевод в проектах для всех участников компании",
  unblock_translation_confirm: "Вы действительно хотите разблокировать автоматический перевод в проектах для всех участников компании",
  please_select_file: "Пожалуйста, выберите файл для загрузки",
  role_in_building_industry: "Роль в строительной индустрии*",
  invalid_email_address: "Недействительный адрес электронной почты",
  please_enter_password: "Пожалуйста, введите пароль",
  password_change_email_sent: "На вашу электронную почту Kjuup отправлено письмо. Подтвердите новый пароль, перейдя по ссылке в письме.",
  please_enter_username: "Пожалуйста, введите имя пользователя",
  username_same_as_before: "Имя пользователя не может быть таким же, как раньше",
  profile_deleted_successfully: "Профиль успешно удален",
  hardware_requirements: "Требования к оборудованию",
  hardware_requirements_list: "• 4 ГБ ОЗУ<br/>• Скорость процессора мин. 2 ГГц<br/>• Windows 7 или выше / все версии macOS",
  submitting: "Отправка...",
  signing_in: "Вход...",
  please_enter_service_name: "Пожалуйста, введите название услуги",
  something_went_wrong_error: "Ааа! Что-то пошло не так...",
  something_went_wrong_try_again: "Извините, что-то пошло не так. Попробуйте снова",
  position_label: "Должность:",
  loading_room: "Загрузка проекта...",
  navigating_to_room: "Переход в проект",
  loading_chat: "Загрузка чата...",
  translate: "Перевести",
  show_original: "Показать оригинал",
  saving: "Сохранение...",
  language_selection_info: "Выбор языка используется для всех подтверждений по электронной почте, связанных с компанией.",
  // Navigation bar labels
  nav_call: "Звонок",
  nav_home: "Главная",
  nav_messages: "Сообщения",
  nav_todo: "задачи",
  nav_rooms: "Проекты",
  nav_all_rooms: "Все проекты",
  pinned_rooms_max: "Можно закрепить до 10 проектов.",
  pinned_room_unpin: "Открепить",
  pinned_rooms_drop: "Перетащите проект сюда для быстрого выбора",
  nav_profile: "Профиль",
  nav_company: "Компания",
  nav_company_documents: "Документы",
  nav_logout: "Выйти",
  // Create message dialog
  add_member_title: "Добавить участника",
  continue_btn: "Продолжить",
  search_placeholder: "Поиск",
  no_members_found: "Участники не найдены",
  no_groups_found: "Группы не найдены",
  no_rooms_found: "Проекты не найдены",
  search_users_tab: "Пользователи",
  search_documents_tab: "Документы",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Нет файлов",
  no_documents_available: "No documents",
  searching_users: "Поиск пользователей...",
  no_users_found: "Пользователи не найдены",
  search_emails_tab: "Эл. почта",
  searching_emails: "Поиск писем...",
  no_emails_found: "Письма не найдены",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Группа без названия",
  unnamed_room: "Проект без названия",
  all_members: "Все",
  room_label: "Проект:",
  subject_label: "Тема:",
  no_members: "Нет участников",
  // Loading states for room creation
  creating_structure: "Создание вашей структуры",
  opening_chat: "Открытие чата",
  please_wait: "Пожалуйста, подождите...",
  // ToDo page translations
  loading_todo: "Загрузка ToDo...",
  task_updated: "Задача обновлена",
  error_updating_task: "Ошибка обновления задачи",
  task_deleted: "Задача удалена",
  error_deleting_task: "Ошибка удаления задачи",
  delete_task_confirm: "Вы уверены, что хотите удалить эту задачу?",
  description_label: "Описание",
  description_placeholder: "Введите описание...",
  date_time_label: "Дата и время",
  save_hint: "Ctrl+Enter для сохранения, Esc для отмены",
  edit_label: "Редактировать",
  delete_label: "Удалить",
  todo_list_title: "задачи",
  tasks_count: "задач",
  search_placeholder_todo: "Поиск...",
  select_task_to_open_chat: "Выберите задачу, чтобы открыть чат",
  today: "Сегодня",
  yesterday: "Вчера",
  time_suffix: "", // Empty for Russian (24h format doesn't need suffix)
  from_chat: "Исходная задача",
  assigned_to: "Назначено",
  assign_users: "Назначить пользователей",
  no_users_assigned: "Нет назначенных пользователей",
  assign: "Назначить",
  assign_to: "Назначить...",
  navigate_to_chat: "Перейти к чату",
  navigate_to_email: "Перейти к письму",
  show_original_message: "Показать источник",
  hide_original_message: "Скрыть источник",
  status_pending: "Ожидает",
  status_in_progress: "В процессе",
  status_completed: "Завершено",
  show: "Показать",
  close: "Закрыть",
  status_confirmed: "Подтверждено",
  log_todo_created: "Задача создана",
  log_todo_confirmed: "Задача подтверждена",
  log_todo_deleted: "Задача удалена",
  log_todo_updated: "Задача обновлена",
  log_description_updated: "Описание обновлено",
  log_deadline_updated: "Срок обновлен",
  log_assigned_to: "Назначено {name}",
  log_unassigned_from: "Снято с {name}",
  log_assignment_added: "Назначение добавлено: {name}",
  log_assignment_removed: "Назначение удалено: {name}",
  log_status_updated: "Статус изменен с {from} на {to}",
  log_status_changed: "Статус изменен",
  log_status_changed_to: "Статус изменен на {status}",
  log_changed_status_to: "Изменил статус на:",
  log_for_user: "для пользователя:",
  log_user_updated_status: "Пользователь обновил статус задачи",
  log_changed_date_to: "Изменил дату на:",
  log_changed_description_to: "Изменил описание на:",
  log_moved_to: "Перемещено в {status}",
  todo_status_updated_from: "с",
  todo_status_updated_to: "на",
  filter_pending: "Ожидает",
  filter_confirmed: "Подтверждено",
  my_list: "Мой день",
  todo_adjust_list: "Редактировать список",
  apply: "Применить",
  filter_assigned_to_me: "Мои задачи",
  filter_assigned_by_me: "Делегировано",
  todo_project_label: "Проект:",
  assigned_users: "Назначенные пользователи:",
  todo_chat_label: "Чат:",
  history: "История",
  todo_assigned_by: "Назначено:",
  todo_assigned_push: "Назначено ToDo:",
  todo_assigned_push_empty: "Вам назначено новое ToDo.",
  search_groups: "Группы",
  search_chat_groups: "Чат-группы",
  search_project_room: "Проект",
  search_messages_tab: "Сообщения",
  searching_groups: "Поиск групп...",
  searching_rooms: "Поиск проектов...",
  no_groups_found: "Группы не найдены",
  no_rooms_found: "Проекты не найдены",
  // ToDo filter translations
  todo_filters: "Фильтры",
  todo_filter_by_project: "Фильтр по проекту",
  todo_status: "Статус",
  todo_assignment: "Назначение",
  todo_filter_by_user: "Фильтр по назначенному лицу",
  todo_active_filters: "Активные фильтры:",
  todo_progress: "Прогресс",
  todo_my_list_empty: "Ваш день пуст",
  todo_my_list_empty_hint: "Нажмите кнопку выше, чтобы добавить задачи",
  create_poll: "Опрос",
  poll_question_label: "ВОПРОС",
  poll_question_placeholder: "Задайте вопрос",
  poll_options_label: "ВАРИАНТЫ",
  poll_option: "Вариант",
  poll_add_option: "Добавить вариант",
  poll_allow_multiple: "Разрешить несколько ответов",
  poll_multiple_allowed: "Выберите один или несколько вариантов",
  poll_select_option: "Выберите один вариант",
  poll_view_votes: "Посмотреть голоса",
  poll_vote_singular: "голос",
  poll_vote_plural: "голосов",
  poll_votes: "Результаты голосования",
  poll_no_votes_yet: "Пока нет голосов",
  transcript_step_processing: "Транскрипция выполняется...",
  ai_transcript_tab: "AI-Транскрипция",
  ai_transcript_info: "Доступно только для голосовых сообщений, созданных после 09.03.2026.",
  transcript_more: "...ещё",
  transcript_less: "...меньше",
  ki_transcript_voice_message: "KI-Транскрипт голосового сообщения",
  ki_image_analysis: "ИИ-анализ изображений",
  type_message: "Введите сообщение",
  email_tab_messages: "Сообщения",
  email_tab_email: "Эл. почта",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Учетные записи почты",
  email_connect_gmail: "Подключить Gmail",
  email_connect_outlook: "Подключить Outlook",
  email_no_accounts: "Нет подключенных учетных записей",
  email_no_accounts_hint: "Подключите учетную запись в настройках профиля",
  email_no_messages: "Нет писем",
  email_from: "От",
  email_to: "Кому",
  email_subject: "Тема",
  email_disconnect: "Отключить",
  email_disconnect_confirm: "Вы уверены, что хотите отключить эту учетную запись электронной почты? Все синхронизированные письма будут удалены.",
  email_account_disconnected: "Учётная запись электронной почты отключена",
  email_account_disconnect_failed: "Не удалось отключить учётную запись",
  email_connecting: "Подключение...",
  email_account_connected: "Учетная запись успешно подключена",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Перейти в настройки",
  email_date: "Дата",
  email_reply: "Ответить",
  email_forward: "Переслать",
  email_copy_text: "Копировать текст",
  email_text_copied: "Скопировано!",
  email_text_copy_failed: "Не удалось скопировать текст.",
  email_delete: "Удалить",
  email_not_spam: "Не спам",
  email_not_spam_success: "Письмо перемещено во входящие.",
  email_not_spam_failed: "Не удалось переместить во входящие.",
  email_delete_confirm: "Вы уверены, что хотите удалить это письмо?",
  email_delete_from_folder: "Вы уверены, что хотите удалить из {folder}?",
  email_delete_permanent_from_folder:
    "Вы уверены, что хотите окончательно удалить из {folder}? Это действие нельзя отменить.",
  email_save_draft_confirm: "Вы хотите сохранить это письмо как черновик?",
  email_save_draft: "Сохранить черновик",
  email_discard: "Удалить",
  email_back_to_compose: "Вернуться к написанию",
  email_draft_saved: "Черновик сохранён.",
  email_draft_save_failed: "Не удалось сохранить черновик.",
  email_loading: "Загрузка писем...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Выбрать",
  email_attachment_singular: "Вложение",
  email_attachment_plural: "Вложения",
  email_back: "Назад",
  email_download: "Скачать",
  email_close: "Закрыть",
  email_preview: "Просмотр",
  email_preview_not_available: "Предпросмотр недоступен",
  email_preview_failed: "Предпросмотр недоступен",
  select_attachments: "Выбрать вложения",
  email_loading_preview: "Загрузка предварительного просмотра...",
  email_mark_unread_failed: "письмо(а) не удалось отметить как непрочитанные.",
  email_delete_failed: "письмо(а) не удалось удалить.",
  filter_all: "Все",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Прямые сообщения",
  my_notes: "My Space",
  filter_internal_groups: "Внутренние групповые чаты",
  filter_external_groups: "Внешние групповые чаты",
  filter_group_chats: "Групповые чаты",
  filter_groups_internal: "Внутренние",
  filter_groups_external: "Внешние",
  filter_unread_only: "Только непрочитанные",
  room_daily_briefing_info: "Если включено, отчёт для этого проекта создаётся каждые 24 часа в указанное в личных настройках время — но только при наличии активности за этот период.",
  email_select_all: "Выбрать все",
  email_deselect_all: "Снять выделение",
  email_reply_all: "Ответить всем",
  email_reply_placeholder: "Введите ваш ответ...",
  email_forward_placeholder: "Добавьте сообщение...",
  email_edit_draft: "Редактировать черновик",
  email_attach: "Прикрепить",
  email_attachment_from_original: "Из оригинального сообщения",
  email_remove: "Удалить",
  email_drop_files: "Перетащите файлы для прикрепления",
  email_loading_attachments: "Загрузка вложений...",
  email_archive: "Архивировать",
  mark_unread: "Отметить как непрочитанное",
  mark_read: "Отметить как прочитанное",
  email_all_accounts: "Все аккаунты",
  email_error: "Ошибка",
  email_delete_email_failed: "Не удалось удалить письмо.",
  enter_url: "Введите URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Подписаться сейчас',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 МЕСЯЦ БЕСПЛАТНО',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Сегодня платить не нужно. Данные банковской карты не запрашиваются до начала платной подписки.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Управляйте всеми почтовыми аккаунтами прямо в Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'ИИ пишет ответы – вы только подтверждаете',
  kjuup_io_feature_tasks: 'Задачи и календарь всегда автоматически актуальны',
  kjuup_io_choose_plan: 'Выберите план',
  kjuup_io_plan_monthly: 'Ежемесячно',
  kjuup_io_plan_yearly: 'Ежегодно',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Защищено Stripe · отмена в любое время',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Оплата получена. Подписка активируется…',
  kjuup_io_toast_activating_soon: 'Оплата получена. Ваша подписка скоро будет активирована.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Осталось {count} ч',
  kjuup_io_trial_left_hour: 'Остался 1 час',
  kjuup_io_trial_left_minutes: 'Осталось {count} мин',
  kjuup_io_trial_left_minute: 'Осталась 1 минута',
  kjuup_io_trial_left_seconds: 'Осталось {count} сек',
  kjuup_io_trial_left_second: 'Осталась 1 секунда',
  kjuup_io_trial_ending_now: 'Пробный период заканчивается…',
  kjuup_io_request_timeout: 'Время ожидания соединения истекло. Попробуйте снова.',
  kjuup_io_info_days_free: '{days} дней полностью бесплатно – подписка начинается только после пробного периода.',
  kjuup_io_discount_total: 'Ваша скидка: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Личная: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Закрыть',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Ваш бесплатный пробный период закончился',
  kjuup_io_trial_ended_body: 'Оформите подписку на Kjuup.io, чтобы и дальше пользоваться почтой и другими премиум-функциями.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Ваш бесплатный пробный период начался',
  kjuup_io_toast_trial_fail: 'Не удалось начать пробный период',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / месяц',
  kjuup_io_save_amount_year: 'Экономия {price} в год',
  kjuup_io_billed_annually_amount: '{price} ежегодно',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Что вы получаете:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Кредитная карта не нужна – начните сразу без платёжных данных.',
  kjuup_io_info_cancel_anytime: 'Отмена в любое время – без обязательств, без риска.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Расчётный период',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Способ оплаты сохранён. Списание произойдёт по окончании пробного периода.',
  calendar_sync_info: 'Автоматически синхронизируйте все задачи Kjuup ToDo с вашим календарём.',
  calendar_no_accounts: 'Календарь ещё не подключён.',
  article_new_badge: 'НОВОЕ',
  article_new_posts: 'Новых публикаций: {0}',
  documents: 'Документы',
  add_documents: 'Добавить документы',
  no_preview_available: 'Предварительный просмотр недоступен',
  no_preview_hint: 'Этот тип файла нельзя предварительно просмотреть, но он всё равно будет отправлен.',
  max_documents_reached: 'Можно прикрепить не более 10 документов за раз.',
  open_file: 'Открыть файл',
  twofa_title: 'Двухфакторная аутентификация',
  twofa_method_totp: 'Приложение-аутентификатор',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'Эл. почта',
  twofa_enter_app: 'Введи 6-значный код из приложения-аутентификатора.',
  twofa_enter_sms: 'Введи 6-значный код из SMS.',
  twofa_enter_email: 'Введи 6-значный код из письма.',
  twofa_resend: 'Отправить код ещё раз',
  twofa_try_another: 'Другой способ',
  twofa_remember_device: 'Не спрашивать на этом устройстве 30 дней',
  twofa_sent: 'Мы отправили код.',
  twofa_invalid_code: 'Неверный код. Попробуй ещё раз.',
  twofa_something_wrong: 'Что-то пошло не так. Попробуй ещё раз.',
  twofa_method_unavailable: 'Этот способ недоступен.',
  twofa_on_desc: 'Двухфакторная аутентификация включена. Код понадобится при каждом входе.',
  twofa_off_desc: 'Добавь второй шаг после пароля. Приложения-аутентификаторы — самый надёжный вариант.',
  twofa_methods: 'Способы',
  twofa_on: 'Вкл.',
  twofa_add: 'Добавить',
  twofa_default_method: 'Способ по умолчанию',
  twofa_default: 'По умолчанию',
  twofa_turn_off: 'Отключить',
  twofa_disable_hint: 'Введи пароль и текущий код, чтобы отключить двухфакторную аутентификацию.',
  twofa_disable_need: 'Введи пароль и код подтверждения.',
  twofa_code_placeholder: '6-значный или резервный код',
  twofa_send_code: 'Отправить код',
  twofa_primary_updated: 'Способ по умолчанию обновлён.',
  twofa_disabled: 'Двухфакторная аутентификация выключена.',
  twofa_enabled: 'Двухфакторная аутентификация включена.',
  twofa_totp_help: 'Отсканируй QR-код в Google Authenticator, Authy или 1Password. Ключ можно ввести и вручную.',
  twofa_secret_copied: 'Ключ скопирован',
  twofa_sms_help: 'Введи номер в международном формате. Мы отправим 6-значный код по SMS.',
  twofa_email_help: 'Мы отправим 6-значный код на почту аккаунта.',
  twofa_backup_title: 'Резервные коды',
  twofa_backup_help: 'Сохрани эти одноразовые коды в надёжном месте. Каждый код можно использовать один раз, если потеряешь телефон.',
  twofa_copy_codes: 'Скопировать коды',
  twofa_codes_copied: 'Резервные коды скопированы',
  twofa_regenerate: 'Получить новые резервные коды',
  twofa_regenerate_hint: 'Это заменит неиспользованные резервные коды. Введите пароль и актуальный код.',
  twofa_backup_remaining: 'Осталось неиспользованных резервных кодов: {n}',
  twofa_new_codes: 'Новые резервные коды',
  twofa_sms_unavailable: 'Коды по SMS пока недоступны.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Назначенные вам задачи Kjuup копируются в проект «Kjuup» в Todoist. Изменения в Todoist не копируются обратно.",
  todoist_connect: "Подключить Todoist",
  todoist_connected: "Todoist подключён",
  todoist_connect_failed: "Не удалось подключить Todoist",
  todoist_disconnect: "Отключить",
  todoist_disconnected: "Todoist отключён",
  todoist_disconnect_confirm: "Отключить Todoist? Задачи, уже созданные в Todoist, останутся. Синхронизация остановится.",
  todoist_sync_now: "Синхронизировать",
  todoist_syncing: "Синхронизация…",
  todoist_sync_done: "Синхронизация завершена",
  todoist_sync_failed: "Ошибка синхронизации",
  todoist_auth_error: "Подключите Todoist снова, чтобы продолжить синхронизацию.",
  todoist_last_sync: "Последняя синхронизация",
  todoist_not_connected: "Todoist не подключён",
  todoist_auth_url_failed: "Не удалось открыть страницу авторизации Todoist.",
  recommend_text: "Присоединяйся к Kjuup, чтобы оставаться на связи и держать общение в порядке. Объедини свои каналы, храни сообщения в нужных проектах и начинай каждое утро со сводки и своих задач – всё синхронизировано с приложениями, которыми ты уже пользуешься. Начни бесплатно:",
  pro_auth_signin_title: 'С возвращением',
  pro_auth_signin_sub: 'Войдите с рабочим email.',
  pro_auth_email_or_username: 'Email или имя пользователя',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'Забыли пароль?',
  pro_auth_create_account: 'Создать аккаунт',
  pro_auth_show_password: 'Показать пароль',
  pro_auth_hide_password: 'Скрыть пароль',
  pro_auth_register_sub: 'Мы отправим вам ссылку для подтверждения email.',
  pro_auth_register_plus_sub: 'Выберите имя пользователя и пароль. Затем вы зададите свой PIN-код безопасности.',
  pro_auth_check_credentials: 'Проверьте ваш email и пароль',
  pro_news_export_pdf: 'Экспортировать в PDF',
  pro_news_pdf_failed: 'Не удалось создать PDF.',
  pro_news_pdf_attachments: 'Вложения',
  pro_news_pdf_video: 'Видео',
  pro_auth_forgot_sub: 'Введите ваш email, и мы отправим вам ссылку для сброса пароля.',
  pro_auth_send_link: 'Отправить ссылку для сброса',
  pro_auth_plus_reset: 'Сбросить с помощью PIN',
  pro_auth_show_pin: 'Показать PIN',
  pro_auth_hide_pin: 'Скрыть PIN',
  v2_auth_plus_only: 'Только Kjuup+',
  room_action_media: "Файлы",
  room_tab_overview: "Обзор",
  room_tab_history: "История",
  chat_info_media: "Файлы",
  messages: "сообщения",
  pro_todo_project_required: "Выберите проект",
  pro_todo_choose_project: "Для какого проекта эта задача?",
  cockpit_report_delete_confirm: "Удалить этот ежедневный отчёт?",
  cockpit_report_deleted: "Ежедневный отчёт удалён",
  cockpit_tab_company: "Компания",
  cockpit_bookmarked_priorities: "Отмеченные задачи",
  cockpit_load_error: "Не удалось загрузить Cockpit.",
  cockpit_retry: "Повторить",
  cockpit_yesterday: "Вчера",
  cockpit_greeting_morning: "Доброе утро",
  cockpit_greeting_day: "Добрый день",
  cockpit_greeting_evening: "Добрый вечер",
  cockpit_assistant_q_open: "Что открыто сегодня?",
  cockpit_assistant_q_summarize: "Кратко изложить чат {{room}}",
  cockpit_assistant_q_overdue: "Какие задачи просрочены?",
  cockpit_assistant_new: "{{n}} новых",
  cockpit_assistant_important: "{{n}} важных",
  cockpit_assistant_title: "Ассистент Kjuup",
  cockpit_assistant_hint: "Нажмите и спросите",
  room_overview_priority_no_detail: "В отчёте нет дополнительных сведений об этом приоритете.",
  room_overview_priority_from: "Источник: {{name}}",
  room_overview_priority_open_task: "Открыть задачу",
  cockpit_priority_position: "{{index}} из {{total}} приоритетов",
  room_overview_today_title: "Важно сегодня",
  room_overview_all_tasks: "Все",
  room_overview_tasks_empty: "Нет открытых сроков и задач",
  room_overview_appointments_empty: "Нет предстоящих встреч",
  room_overview_no_priorities: "В последнем отчёте нет открытых приоритетов.",
  cockpit_report_top5: "Топ-5 приоритетов",
  cockpit_report_todo_created: "Задача создана",
  cockpit_report_source_missing: "Исходное сообщение не найдено.",
  delete_bookmarked_priority_confirm: "Вы действительно хотите удалить эту отмеченную задачу?",
  cockpit_report_create_todo: "Создать задачу",
  cockpit_priorities_deleting: "Удаление …",
  cockpit_priorities_select: "Удалить несколько",
  cockpit_report_none: "Нет записей.",
  cockpit_priorities_delete_confirm: "Вы действительно хотите удалить отмеченные задачи ({count})?",
  cockpit_priorities_delete_failed: "Не удалось удалить задачи: {count}",
  cockpit_priorities_deleted: "Удалено задач: {count}",
  cockpit_priorities_selected: "Выбрано: {count}",
  cockpit_channel_connected: "Подключено",
  cockpit_channel_not_connected: "Не подключено",
  cockpit_channel_connect: "Подключить",
  cockpit_channel_chat: "Чат Kjuup",
  cockpit_channel_active: "Активно",
  cockpit_channel_hidden: "Скрыто",
  cockpit_channel_enable: "Включить",
  cockpit_channel_email: "Эл. почта",
  cockpit_channel_check: "Проверить подключение",
  cockpit_channel_fix: "Проверить",
  cockpit_channel_forward: "Адрес пересылки",
  cockpit_channel_not_set_up: "Не настроено",
  cockpit_channel_set_up: "Настроить",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Соединение потеряно",
  cockpit_channel_importing: "Импорт",
  cockpit_channel_removing: "Отключение",
  cockpit_channel_reconnect: "Подключить снова",
  cockpit_channels_title: "Каналы",
  cockpit_company_role_super_admin: "Администратор компании",
  cockpit_company_role_dept_admin: "Администратор отдела",
  cockpit_company_role_member: "Сотрудник",
  cockpit_company_none: "Компания с Kjuup+ не найдена",
  cockpit_company_eyebrow: "Компания",
  cockpit_company_inactive: "неактивна",
  cockpit_company_settings: "Настройки компании",
  cockpit_company_employees: "Сотрудники",
  cockpit_company_internal_rooms: "Внутренние проекты",
  cockpit_report_all_projects: "Все проекты",
  cockpit_report_progress_emails: "Анализ писем",
  cockpit_report_progress_chats: "Анализ сообщений чата",
  cockpit_report_progress_documents: "Анализ вложений и документов",
  cockpit_report_progress_tasks: "Анализ задач",
  cockpit_report_progress_summarizing: "Анализ содержимого",
  cockpit_report_progress_reading: "Использование уже проанализированного содержимого",
  cockpit_report_progress_collecting: "Сбор писем, чатов и задач из ваших проектов",
  cockpit_report_progress_priorities: "Составление приоритетов, сроков и решений",
  cockpit_report_progress_queued: "Подготовка отчёта",
  cockpit_report_creating_title: "Ваш ежедневный отчёт готовится",
  cockpit_report_progress_count_one: "Проанализирован 1 элемент",
  cockpit_report_progress_count_many: "Проанализировано элементов: {{count}}",
  cockpit_report_progress_hint: "Обычно это занимает одну-две минуты – всё это время вы можете продолжать работать в Cockpit.",
  cockpit_report_time_hint: "Ежедневный отчёт создаётся каждый день в {{hour}}:00 для пяти самых активных проектов.",
  room_overview_priorities_title: "Текущее состояние и приоритеты",
  room_overview_as_of: "По состоянию на {{time}}",
  cockpit_report_delete: "Удалить ежедневный отчёт",
  email_tag_daily_briefing: "Ежедневный отчёт",
  cockpit_report_unread: "Новый",
  cockpit_report_clear_project: "Показать все проекты",
  cockpit_filter_project: "Проект",
  cockpit_filter_all_projects: "Все проекты",
  cockpit_report_recreate: "Создать ежедневный отчёт заново",
  cockpit_report_hide_previous: "Скрыть предыдущие ежедневные отчёты",
  cockpit_report_show_previous: "Показать предыдущие ежедневные отчёты",
  cockpit_report_room_empty: "Для этого проекта ещё нет ежедневного отчёта",
  cockpit_report_empty: "Ежедневного отчёта пока нет",
  cockpit_report_room_empty_hint: "Создайте ежедневный отчёт только для этого проекта.",
  cockpit_report_needs_mailbox: "Подключите почтовый аккаунт, чтобы Kjuup мог создавать ежедневный отчёт с автоматическими задачами.",
  cockpit_report_create: "Создать ежедневный отчёт",
  cockpit_email_connect: "Подключить почту",
  cockpit_email_none_title: "Почтовый аккаунт ещё не подключён",
  cockpit_email_none_reports: "Подключите почтовый ящик, чтобы Kjuup распределял входящие письма по вашим проектам и создавал ежедневные отчёты с задачами.",
  cockpit_email_none_client: "Подключите Gmail, Outlook или IMAP, чтобы читать письма, распределять их и отвечать на них прямо в Kjuup.io.",
  cockpit_email_reports_title: "Текущий почтовый клиент",
  cockpit_email_reports_text: "Без входящих в Kjuup.io · проектов с ежедневным отчётом в {{hour}}:00: {{rooms}} · входящие письма распределяются по вашим проектам.",
  cockpit_email_reports_rooms: "Управление проектами",
  cockpit_email_settings: "Настройки почты",
  cockpit_email_error_title: "Проверить подключение",
  cockpit_email_client_title: "Входящие подключены",
  cockpit_email_accounts_n: "Подключено аккаунтов: {{n}}",
  cockpit_email_last_sync: "последняя синхронизация {{when}}",
  cockpit_email_report_at: "Ежедневный отчёт в {{hour}}:00",
  cockpit_email_open_inbox: "Открыть входящие",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Подключённые адреса эл. почты",
  email_folder_sent: "Отправленные",
  email_no_subject: "(Без темы)",
  cockpit_email_detail_loading: "Загрузка письма …",
  cockpit_email_detail_failed: "Не удалось загрузить письмо.",
  cockpit_email_detail_empty: "В этом письме нет текста.",
  cockpit_personal_settings: "Личные настройки",
  cockpit_companies: "Компании",
  cockpit_title: "Cockpit",
  cockpit_back: "Назад к обзору",
  cockpit_day_overview: "Ваш день вкратце",
  email_saved_to_project: "Письмо сохранено в проекте",
  email_classify_need_project: "Введите название проекта",
  cockpit_email_deleted: "Письмо удалено",
  cockpit_email_sent_empty: "Отправленных писем пока нет.",
  cockpit_email_incoming_empty: "Входящих писем пока нет.",
  cockpit_email_incoming_title: "Письма",
  cockpit_email_incoming_sub: "Распределяйте входящие и отправленные письма по вашим проектам. Здесь можно изменить распределение.",
  cockpit_email_incoming_unassigned_n: "Не распределено: {{n}}",
  cockpit_email_folder_inbox: "Входящие",
  cockpit_email_folder_sent: "Отправленные",
  cockpit_email_open: "Открыть письмо",
  cockpit_email_incoming_suggested: "Предложение: {{room}}",
  cockpit_email_incoming_apply: "Применить",
  cockpit_email_incoming_adjust: "Изменить распределение",
  cockpit_email_incoming_saving: "Сохранение …",
  cockpit_email_incoming_unassigned: "Не распределено",
  cockpit_email_incoming_show_less: "Показать меньше",
  cockpit_email_incoming_show_all: "Показать все ({{n}})",
  cockpit_io_settings: "Настройки Kjuup.io",
  cockpit_io_settings_sub: "Тариф и места, назначение сотрудников, оплата и счета.",
  products_coming_soon: "Скоро",
  cockpit_upsell_io_title: "Ваш офис, который думает вместе с вами",
  cockpit_upsell_io_text: "Подключите свои почтовые аккаунты к Kjuup. Письма, вложения и сообщения автоматически сохраняются в нужном проекте и при желании могут храниться на вашем сервере. Каждый день вы получаете сводку по всем проектам с главным из всего содержимого, а ваши задачи синхронизируются с календарём или приложением для задач.",
  cockpit_upsell_io_soon_title: "Пока недоступно для заказа",
  cockpit_upsell_io_soon_text: "Kjuup.io скоро выйдет. Запросите информацию сейчас – мы сообщим вам, как только Kjuup.io можно будет заказать.",
  cockpit_upsell_io_planned_price: "Планируемая цена",
  cockpit_upsell_io_cta_request: "Запросить информацию",
  kjuup_plus_abo_per_year: "/ год",
  kjuup_plus_abo_per_month: "/ месяц",
  kjuup_plus_abo_status_active: "Активна",
  kjuup_plus_abo_status_requested: "Запрошена отмена",
  kjuup_plus_abo_status_past_due: "Платёж просрочен",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Подписка",
  kjuup_plus_abo_title: "Пакет Kjuup+",
  kjuup_plus_abo_seats_free_one: "Осталось 1 место",
  kjuup_plus_abo_billing: "Оплата",
  kjuup_plus_abo_yearly: "Ежегодно",
  kjuup_plus_abo_monthly: "Ежемесячно",
  kjuup_plus_abo_amount: "Сумма",
  kjuup_plus_abo_ends: "Действует до",
  kjuup_plus_abo_renews: "Следующее продление",
  kjuup_plus_abo_next_invoice: "Следующий счёт",
  kjuup_plus_abo_intro: "Вводная цена",
  kjuup_plus_abo_pending_tier: "С ближайшего продления",
  kjuup_plus_abo_manual: "Kjuup+ активен для вашей компании по индивидуальному соглашению.",
  kjuup_plus_abo_invoices: "Счета",
  kjuup_plus_abo_invoice_paid: "Оплачен",
  kjuup_plus_abo_invoice_view: "Просмотреть",
  kjuup_plus_abo_invoices_less: "Показать меньше",
  kjuup_plus_abo_member_hint: "Оплатой и отменой управляют администраторы вашей компании.",
  kjuup_plus_abo_withdraw: "Отозвать запрос",
  kjuup_plus_abo_cancel_note: "Причина (необязательно)",
  kjuup_plus_abo_cancel_send: "Запросить отмену",
  kjuup_plus_abo_cancel: "Отменить подписку",
  cockpit_upsell_plus_f1: "Управляйте коммуникацией всех ваших сотрудников",
  cockpit_upsell_plus_f2: "Информируйте определённые группы пользователей внутри компании",
  cockpit_upsell_plus_f3: "Сохраняйте внутренние групповые чаты",
  cockpit_upsell_plus_when_yearly: "при годовой оплате",
  cockpit_upsell_plus_size_small: "1–50 сотрудников",
  cockpit_upsell_plus_size_large: "51–200 сотрудников",
  cockpit_upsell_plus_title: "Kjuup+ для компаний",
  cockpit_upsell_plus_text: "Управляйте сотрудниками, правами на запись и корпоративной коммуникацией в одном месте. Внутренние каналы остаются в вашей команде, внешние каналы связывают вас с партнёрами по проектам, а определённые группы можно охватить напрямую. Помимо Kjuup+, вы можете заказать доступ к Kjuup.io для групп сотрудников. Kjuup+ и Kjuup.io можно комбинировать.",
  cockpit_upsell_plus_size: "Размер компании",
  cockpit_upsell_plus_billing: "Оплата",
  cockpit_upsell_plus_per_company: "/ компания · месяц без НДС",
  cockpit_upsell_plus_onboarding: "Стоимость внедрения/обучения зависит от размера компании",
  cockpit_upsell_plus_larger: "Цены для более крупных компаний по запросу",
  cockpit_upsell_plus_cta: "Запрос без обязательств",
  cockpit_kpi_deadlines_tasks: "Сроки и задачи",
  cockpit_kpi_appointments: "Встречи",
  cockpit_room_admin: "Управление проектами и чатами",
  cockpit_room_admin_sub: "Все проекты компании с участниками, медиа и чатами.",
  pro_todo_not_found: "Эта задача больше недоступна.",
  cockpit_chip_overdue: "Просрочено",
  cockpit_chip_today: "Сегодня",
  cockpit_calendar_week: "Нед. {{week}}",
  cockpit_prev_week: "Предыдущая неделя",
  cockpit_next_week: "Следующая неделя",
  cockpit_chip_requested: "Запрошено",
  cockpit_todo_due: "Срок {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "от {{name}}",
  cockpit_todo_since: "с {{when}}",
  cockpit_todo_no_date: "Без даты",
  cockpit_todo_mark_done: "Отметить как выполненную",
  cockpit_my_tasks_title: "Мои задачи",
  cockpit_today_tasks_group: "Задачи на сегодня",
  cockpit_assign_none: "Никто не назначен",
  no_project_found: "Проект не найден",
  cockpit_row_more_actions: "Другие действия",
  needs_date: "Назначить дату",
  cockpit_assign_proposal: "Распознан(а) {{name}} – назначить?",
  cockpit_assign_proposal_confirm: "Назначить",
  cockpit_assign_proposal_dismiss: "Игнорировать",
  cockpit_priority_date: "Дата",
  todo_calendar_add: "Добавить в календарь",
  todo_calendar_remove: "Удалить из календаря",
  cockpit_todo_change_project: "Сменить проект",
  cockpit_todo_set_date: "Указать дату",
  pro_todo_done_confirm: "Вы действительно хотите отметить эту задачу как выполненную?",
  cockpit_task_delete_failed: "Не удалось удалить задачу.",
  cockpit_setup_title: "Завершите настройку",
  cockpit_setup_text: "Решите, хотите ли вы использовать чаты и будет ли Kjuup.io работать как почтовый клиент или только с проектами и ежедневными отчётами.",
  cockpit_setup_cta: "Настроить сейчас",
  cockpit_group_tasks: "Сроки и задачи",
  cockpit_group_appointments: "Встречи",
  cockpit_report_no_activity: "В этом проекте за последние 24 часа не было новых сообщений или писем.",
  cockpit_report_room_unavailable: "Этот проект недоступен.",
  cockpit_report_create_failed: "Не удалось создать ежедневный отчёт.",
  cockpit_report_created: "Ежедневный отчёт создан",
  addon_enable_confirm: "Включить дополнение?",
  addon_enable: "Включить",
  addon_enabled: "Дополнение включено",
  nav_email: "Эл. почта",
  nav_my_cockpit: "Мой Cockpit",
  nav_news: "Новости",
  nav_recommend: "Порекомендовать",
  pro_todo_status_done: "Выполнено",
  pro_todo_status_open: "Открыто",
  v2_todo_remove: "Удалить",
  pro_todo_search_people: "Поиск людей",
  pro_todo_clear: "Очистить",
  pro_todo_assigned: "(назначен)",
  pro_todo_no_people: "Люди не найдены",
  pro_todo_search_rooms: "Поиск проектов",
  pro_todo_no_rooms_match: "Нет проектов, соответствующих «{{q}}»",
  pro_todo_no_rooms: "Проекты не найдены",
  pro_todo_activity: "Активность",
  pro_todo_show_less: "Показать меньше",
  pro_todo_show_all: "Показать все ({{n}})",
  pro_todo_due: "Срок",
  pro_todo_room: "Проект",
  pro_todo_select_room: "Выбрать проект",
  pro_todo_status: "Статус",
  pro_todo_more: "Ещё",
  pro_todo_edit_title: "Редактировать задачу",
  pro_todo_description: "Описание",
  pro_todo_created_by: "Создал(а)",
  pro_todo_chat: "Чат",
  navigate_to_source: "Перейти к источнику",
  todo_calendar_connect_title: "Календарь не подключён",
  todo_calendar_connect_body_web: "Подключите календарь в настройках синхронизации календаря, чтобы добавлять в него задачи.",
  todo_calendar_connect: "Подключить",
  todo_calendar_removed: "Удалено из вашего календаря",
  todo_calendar_added_later: "Добавлено. Ваш календарь недоступен; Kjuup повторит попытку позже.",
  todo_calendar_added: "Добавлено в ваш календарь",
  todo_calendar_no_date: "В календарь можно добавить только задачу с датой.",
  todo_calendar_failed: "Не удалось обновить ваш календарь. Повторите попытку.",
  todo_calendar_date_title: "Даты пока нет",
  todo_calendar_date_save: "Указать дату и добавить",
  todo_calendar_date_body_web: "У этой отмеченной задачи пока нет даты. Укажите дату, чтобы добавить её в календарь.",
  kjuup_io_setup_saved: "Настройка сохранена",
  kjuup_io_setup_step: "Шаг",
  kjuup_io_setup_chats_title: "Хотите использовать чаты?",
  kjuup_io_setup_email_title: "Где вы хотите читать свою почту?",
  kjuup_io_setup_chats_sub: "Чаты с коллегами и партнёрами по проектам необязательны. Вы можете показывать или скрывать их в Cockpit в любое время.",
  kjuup_io_setup_email_sub: "Здесь выбирается только, используете ли вы почтовый клиент в Kjuup или продолжаете пользоваться текущей почтовой программой, например Outlook или другой. Позже это можно изменить.",
  kjuup_io_setup_chats_yes: "Да, показывать чаты",
  kjuup_io_setup_chats_yes_text: "«Сообщения» включают чаты и письма. В проектах есть групповые чаты для всех участников.",
  kjuup_io_setup_chats_no: "Нет, работать без чатов",
  kjuup_io_setup_chats_no_text: "Чаты скрыты. «Сообщения» становятся «Почтой»; проекты, задачи и ежедневные отчёты остаются.",
  kjuup_io_setup_email_client: "Почтовый клиент в Kjuup",
  kjuup_io_setup_email_client_text: "Читайте письма и отвечайте на них прямо в Kjuup.",
  kjuup_io_setup_email_reports: "Текущий почтовый клиент",
  kjuup_io_setup_email_reports_text: "Продолжайте читать и отвечать в текущей программе, например Outlook или другой.",
  kjuup_io_setup_skip: "Позже",
  next: "Далее",
  kjuup_io_setup_finish: "Завершить настройку",
  today_label: "сегодня",
  tomorrow_label: "завтра",
  cockpit_todo_overdue: "просрочено",
  cockpit_report_management_fazit: "Резюме для руководства",
  cockpit_todo_appointment: "Встреча",
  cockpit_todo_deadline: "Срок",
  cockpit_todo_deadline_define: "Указать срок",
  pro_todo_status_acknowledged: "Подтверждено",
  pro_todo_responsible: "Ответственный",
  pro_todo_notice_confirmed: "Подтверждено в чате",
  pro_todo_notice_sent_at: "Сообщение отправлено",
  pro_todo_notice_again: "Отправить сообщение ещё раз",
  pro_todo_notice_send: "Уведомить через сообщение Kjuup",
  pro_todo_add_assignee: "Добавить",
  pro_todo_edit: "Редактировать",
  pro_todo_change_room: "Сменить проект",
  pro_todo_due_on: "Срок до",
  pro_todo_edit_due: "Изменить срок",
  pro_todo_no_date: "Без даты",
  pro_todo_edit_description: "Редактировать описание",
  pro_todo_no_description: "Описания пока нет",
  pro_todo_title_label: "Заголовок",
  pro_todo_title_placeholder: "Введите заголовок...",
  pro_todo_task: "Задача",
  pro_todo_what: "Что нужно сделать?",
  pro_todo_source_email: "Эл. почта",
  pro_todo_sources: "Источники",
  previous: "Предыдущее",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (до {max} сотрудников)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (до {max} сотрудников)",
  kjuup_plus_abo_status_ends: "Заканчивается {date}",
  kjuup_plus_abo_seats_over: "Более {max} сотрудников – Kjuup свяжется с вами с индивидуальным предложением.",
  kjuup_plus_abo_seats_next: "Если присоединится больше сотрудников, пакет автоматически сменится на {next} (с пропорциональным перерасчётом).",
  kjuup_plus_abo_seats_used: "Занято мест: {used} из {total}",
  kjuup_plus_abo_seats_free: "Свободно мест: {count}",
  kjuup_plus_abo_intro_until: "до {date}",
  kjuup_plus_abo_invoice_open: "Не оплачен · срок {date}",
  kjuup_plus_abo_invoices_all: "Показать все ({count})",
  kjuup_plus_abo_requested_hint: "Отмена запрошена {date}. Kjuup подтвердит её в конце срока действия ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup рассмотрит ваш запрос и подтвердит отмену в конце срока действия ({end}). До этого Kjuup+ остаётся активным.",
  kjuup_plus_abo_withdrawn: "Запрос на отмену отозван",
  kjuup_plus_abo_requested: "Отмена запрошена",
  cockpit_upsell_plus_intro_hint: "первые {months} месяца, затем {price}",
  cockpit_upsell_plus_badge: "ВСТУПИТЕЛЬНАЯ ЦЕНА НА {months} МЕСЯЦА",
  calendar_syncing: "Обновление из календаря…",
  calendar_sync_up_to_date: "Календарь актуален",
  calendar_sync_failed: "Ошибка синхронизации",
  delete_multiple_tasks_confirm: "Вы уверены, что хотите удалить {count} ToDo?",
  todos_deleted_count: "Удалено {count} ToDo",
  todos_deleted_partial: "Удалено {ok} ToDo, {fail} с ошибкой",
  todo_unknown: "Неизвестно",
  todo_created_from_message: "Задача создана из этого сообщения",
  kjuup_io_todo_calendar_trial_ended_note: "Синхронизация календаря · Оформить подписку",
  kjuup_io_todo_calendar_nudge: "Синхронизировать эту ToDo с вашим календарём?",
  kjuup_io_todo_calendar_nudge_cta: "Активировать Kjuup.io",
  todo_confirmed: "ToDo подтверждено",
  pro_todo_bulk_delete_title: "Удалить задачи ({{n}})?",
  pro_todo_previous_none_own: "Просроченные задачи вам назначили другие, и удалить их могут только они.",
  pro_todo_previous_none: "Нет просроченных задач",
  pro_todo_previous_title: "Удалить просроченные задачи ({{n}})?",
  pro_todo_previous_text: "Все ваши открытые задачи за прошлые дни будут удалены.",
  pro_todo_previous_skipped: "Задачи, назначенные вам другими, останутся: {{n}}.",
  unassign_task_confirm: "Вы хотите отменить своё назначение на эту задачу?",
  unassign_label: "Отменить",
  pro_todo_delete_title: "Удалить задачу",
  pro_todo_today: "Сегодня",
  pro_todo_yesterday: "Вчера",
  pro_todo_since_yesterday: "Со вчерашнего дня",
  pro_todo_mark_open: "Отметить как открытую",
  verify_completion: "Подтвердить",
  new_label: "Новое",
  bookmarked_no_mylist: "Задачи в закладках нельзя добавить в Мой список",
  delete_only_own: "Вы можете удалять только задачи, созданные вами",
  todo_clear_all: "Очистить все",
  pro_todo_of_completed: "Выполнено {{done}} из {{total}}",
  pro_todo_pick_date: "Выберите дату",
  pro_todo_show_day: "Показать день",
  pro_todo_section_upcoming: "Предстоящие",
  pro_todo_section_done: "Выполнено",
  pro_todo_room_empty_today: "На сегодня в этом проекте нет задач",
  pro_todo_room_empty_day: "В этот день в этом проекте нет задач",
  pro_todo_delete_previous: "Удалить все",
  pro_todo_empty_title: "Здесь ничего нет",
  pro_todo_empty_hint: "Нет задач, соответствующих этому виду.",
  pro_todo_selected: "Выбрано: {{n}}",
  delete_selected_count: "Удалить ({count})",
  pro_todo_adjust_done: "Готово",
  pro_todo_deleting: "Удаление...",
  pro_todo_reopen: "Открыть задачу заново",
  pro_todo_step_done: "Выполнено",
  move_back_in_progress: "Вернуть в работу",
  pro_todo_mark_not_started: "Отметить как «не начато»",
  back_into_in_progress: "Вернуть в работу",
  pro_todo_mark_in_progress: "Отметить как «в работе»",
  unassign_todo: "Отменить назначение ToDo",
  pro_todo_open_room: "Открыть проект",
  pro_todo_new_task: "Новая задача",
  select_user_back_to_in_progress: "Выберите пользователя для возврата в работу",
  cockpit_email_accounts_n_many: "Подключено аккаунтов: {{n}}",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Контакты Kjuup",
  combined_tab_teams: "Контакты Teams",
  combined_bridge_failed: "Не удалось создать копию в Teams.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Контакты Kjuup и Teams: создаётся новая группа, которая также появится в Microsoft Teams.",
  teams_new_chat_title: "Новый чат Teams",
  teams_new_chat_topic: "Название группы (необязательно)",
  teams_new_chat_start: "Начать чат",
  teams_new_chat_creating: "Создание чата…",
  teams_new_chat_forbidden: "Microsoft Teams не разрешает этот чат (например, человек вне вашей организации или правило вашего ИТ-отдела).",
  teams_new_chat_too_many: "Слишком много участников для одного чата.",
  teams_new_chat_type_hint: "Введите имя для поиска в вашей организации.",
  teams_new_chat_directory_forbidden: "Ваша организация не разрешает поиск в каталоге. Показаны только люди из ваших чатов Teams.",
  teams_new_chat_account: "Аккаунт",
};
